import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { login } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";
import CustomInput from "../../components/CustomInput";

function Login(props) {
    const [loading, setLoading] = useState(false);
    const [loadingButtonStyle, setLoadingButtonStyle] = useState({ paddingRight: "1.5rem" });

    const enableLoading = () => {
        setLoading(true);
        setLoadingButtonStyle({ paddingRight: "3rem" });
    };

    const disableLoading = () => {
        setLoading(false);
        setLoadingButtonStyle({ paddingRight: "1.5rem" });
    };

    return (
        <div className="kt-login__body">
            <div className="kt-login__form">
                <div className="kt-login__title">
                    <h3>Sign in</h3>
                </div>

                <Formik
                    initialValues={{ email: "", password: "" }}
                    validate={(values) => {
                        const errors = {};

                        if (!values.email) {
                            errors.email = "Email is required.";
                        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                            errors.email = "Please enter a valid email address.";
                        }

                        if (!values.password) {
                            errors.password = "Password is required.";
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                        enableLoading();

                        login(values.email, values.password)
                            .then((res) => {
                                disableLoading();

                                utils.setStorage("authToken", res.data.token);
                                props.login(res.data);
                            })
                            .catch(() => {
                                disableLoading();

                                setSubmitting(false);

                                setStatus("Invalid email or password.");
                            });
                    }}>
                    {({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                        <form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
                            {status ? (
                                <div role="alert" className="alert alert-danger">
                                    <div className="alert-text">{status}</div>
                                </div>
                            ) : null}

                            <div className="form-group">
                                <CustomInput
                                    required
                                    inheritLabel
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    value={values.email}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errors={errors}
                                    touched={touched}
                                />
                            </div>

                            <div className="form-group">
                                <CustomInput
                                    required
                                    inheritLabel
                                    label="Password"
                                    name="password"
                                    value={values.password}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errors={errors}
                                    touched={touched}
                                />
                            </div>

                            <div className="kt-login__actions">
                                <a href="/password/forgot" className="kt-link kt-login__link-forgot">
                                    Forgot password?
                                </a>

                                <button id="kt_login_signin_submit" type="submit" disabled={isSubmitting || loading} className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx({ "kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light": loading })}`} style={{ ...loadingButtonStyle, minWidth: "110px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    {!loading && (
                                        <>
                                            <i className="fa fa-plus-square" style={{ color: "#FFF", marginRight: "5px" }} />
                                            Sign in
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default connect(null, auth.actions)(Login);
